import React from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import { useCredits } from '../../../context/CreditsContext';

const Credits = () => {
  const { credits, isLoading } = useCredits();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid',
        borderRadius: '8px',
        padding: 1,
        width: 'fit-content',
        backgroundColor: 'background.paper',
        boxShadow: 2,
        marginRight: 4,
      }}
    >
      <Typography variant="h5" color="textSecondary" sx={{ mr: 1 }}>
        Credit:
      </Typography>
      <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold' }}>
        {isLoading ? <CircularProgress size={24} /> : credits}
      </Typography>
    </Box>
  );
};

export default Credits;
